import { renderSelectedFilter } from "./../../items/selected-filter-item/selected-filter-item"
export { }

const selectsSelector = ".se-multi-checkbox"
const selects = document.querySelectorAll(selectsSelector)

const closeAll = () => { selects.forEach(select => select.classList.remove("--active")) }

// Handle click outside
if (selects.length) {
  document.addEventListener("click", (event) => {
    if (!(event.target as Element)?.closest(selectsSelector)) { closeAll() }
  })
}

selects.forEach((select) => {
  const toggler = select.querySelector<HTMLElement>(".se-multi-checkbox__toggler")
  const label = select.querySelector<HTMLElement>(".se-multi-checkbox__label")
  const clearButton = select.querySelector<HTMLElement>(".se-multi-checkbox__clear")
  const count = select.querySelector<HTMLElement>(".i-selected-filter__title")
  const closestSelectedGroup = select.closest(".s-filters")?.querySelector(".g-selected-filters") // uhh
  const closestForm = select.closest<HTMLFormElement>(".s-filters__form") // uhh


  const checkboxes = select.querySelectorAll<HTMLInputElement>("input[type=checkbox]")

  const open = () => {
    closeAll()
    select.classList.add("--active")
  }

  const toggleHandle = () => { select.classList.contains("--active") ? closeAll() : open() }

  toggler?.addEventListener("click", toggleHandle)
  label?.addEventListener("click", toggleHandle)

  const getCheckedCheckboxes = () => [...checkboxes].filter(checkbox => checkbox.checked)

  const getCheckedCount = () => getCheckedCheckboxes().length

  const uncheckAll = () => {
    checkboxes.forEach(checkbox => {
      checkbox.checked = false
      const selectedFilter = document.querySelector(`[data-id="${checkbox.getAttribute("id") ?? ""}"]`)
      selectedFilter?.remove()
    })
  }

  const handleRenderSelectedFilter = (checkbox: HTMLInputElement) => {
    if (!closestSelectedGroup) return

    const selectedFilter = renderSelectedFilter(
      checkbox.dataset.title ?? "",
      checkbox.getAttribute("id") ?? "",
    )
    closestSelectedGroup.appendChild(selectedFilter)
  }

  const handleActivate = (checkbox: HTMLInputElement) => {
    clearButton?.classList.add("--active")
    handleRenderSelectedFilter(checkbox)
  }


  const handleDeactivate = (checkbox: HTMLInputElement) => {
    if (getCheckedCount() <= 0) {
      clearButton?.classList.remove("--active")
    }
    const selectedFilter = document.querySelector(`[data-id="${checkbox.getAttribute("id") ?? ""}"]`)
    selectedFilter?.remove()

  }

  clearButton?.addEventListener("click", () => {
    clearButton.classList.remove("--active")
    uncheckAll()
    closestForm?.dispatchEvent(new Event('filter'))
  })

  getCheckedCheckboxes().forEach(checkbox => {
    handleRenderSelectedFilter(checkbox)
  })

  closestSelectedGroup?.classList.remove("--loading")

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener("change", () => {
      if (count) { count.innerHTML = String(getCheckedCount()) }
      if (checkbox.checked) {
        handleActivate(checkbox)
      } else {
        handleDeactivate(checkbox)
      }
      closestForm?.dispatchEvent(new Event('filter'))

    })
  })
})
